import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchPlatePage = {
  footer: {
    root: 'apply-search-plate-page.footer.root',
  },
  form: {
    h1: 'apply-search-plate-page.form.h1',
    h2: 'apply-search-plate-page.form.h2',
    plateInput: 'apply-search-plate-page.form.plate-input',
    plateInputError: 'apply-search-plate-page.form.plate-input-error',
    root: 'apply-search-plate-page.form.root',
    stateSelect: 'apply-search-plate-page.form.state-select',
    stateSelectError: 'apply-search-plate-page.form.state-select-error',
    submitButton: 'apply-search-plate-page.form.submit-button',
  },
  header: {
    drawerButton: 'apply-search-plate-page.header.drawer-button',
    previousStepButton: 'apply-search-plate-page.header.previous-step-button',
    root: 'apply-search-plate-page.header.root',
  },
  progress: {
    root: 'apply-search-plate-page.progress.root',
  },
} as const satisfies PageLocatorMap;
